<template>
    <div class="px-5 md:px-0">
      <div class="card rounded-3xl bg-white p-6 text-center text-secondary">
        <img src="~/assets/images/icons/icona_house.png" alt="sei un'azienda?" class="py-5 mx-auto">
        <h3 class="text-xl font-bold pt-5">Sei un'azienda?</h3>
        <p class="pb-5 w-96 mx-auto">
          Il Terzo Settore ha tanto da offrire: possiamo supportarti nell’orientamento delle idee regalo solidali che
          incontrano le tue necessità.
        </p>
        <a href="https://italianonprofit.it/strumenti/natale-solidale-aziende/" target="_blank" class="btn btn-block btn-error rounded-full drop-shadow-xl lg:btn-wide flex justify-between mx-auto">
          <span>Scopri di più</span>
          <i class="sa sa-round-arrow-right-up line2"></i>
        </a>
      </div>
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped>

</style>